"use client";
import React from "react";
import { Dialog, DialogBackdrop, Transition } from "@headlessui/react";

import { useModal } from "@/hooks/use-modal";
import ModalInner from "@/modal/modal-inner";

export type HideModalCallback = () => void;

const Modal = () => {
  const { component, closeModal, isOpen } = useModal();

  const dismissable = true; // FIXME

  return (
    <Dialog open={isOpen} onClose={closeModal} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/30 backdrop-blur-xs" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <ModalInner>{isOpen && component}</ModalInner>
      </div>
    </Dialog>
  );
};

export default Modal;
